import { NomeRequest } from 'src/app/shared/models/nome.model';

export interface Pagamamento {
  id: number;
  fornecedor: string;

  parcela: string;
  status: string;
  valor: number;
  valorDesconto: number;
  valorJuros: number;
  valorMulta: number;
  vencimento: Date;
}

export interface PagamamentoRequest {
  dataPagamento: Date;
  historico?: string;
  idcontaCaixa: number;
  tipoPagamento: NomeRequest;
  idParcelas: number[];
}

export interface FaturaParcela {
  status: string;
  invoiceUrl?: string;
  bankSlipUrl?: string;
  value: number;
  dueDate: Date | string;
}

export interface FaturaUso {
  hasPendingPayment: boolean;
  parcelas?: FaturaParcela[];
}

export function obterIdParcela(parcela: FaturaParcela): string | undefined {
  return parcela.bankSlipUrl?.split('/').filter(Boolean).pop();
}
